/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var Hook = require("./Hook");
var HookCodeFactory = require("./HookCodeFactory");
var AsyncParallelBailHookCodeFactory = /*#__PURE__*/ function(HookCodeFactory) {
    _inherits._(AsyncParallelBailHookCodeFactory, HookCodeFactory);
    function AsyncParallelBailHookCodeFactory() {
        _class_call_check._(this, AsyncParallelBailHookCodeFactory);
        return _call_super._(this, AsyncParallelBailHookCodeFactory, arguments);
    }
    _create_class._(AsyncParallelBailHookCodeFactory, [
        {
            key: "content",
            value: function content(param) {
                var onError = param.onError, onResult = param.onResult, onDone = param.onDone;
                var code = "";
                code += `var _results = new Array(${this.options.taps.length});\n`;
                code += "var _checkDone = function() {\n";
                code += "for(var i = 0; i < _results.length; i++) {\n";
                code += "var item = _results[i];\n";
                code += "if(item === undefined) return false;\n";
                code += "if(item.result !== undefined) {\n";
                code += onResult("item.result");
                code += "return true;\n";
                code += "}\n";
                code += "if(item.error) {\n";
                code += onError("item.error");
                code += "return true;\n";
                code += "}\n";
                code += "}\n";
                code += "return false;\n";
                code += "}\n";
                code += this.callTapsParallel({
                    onError: (i, err, done, doneBreak)=>{
                        var code = "";
                        code += `if(${i} < _results.length && ((_results.length = ${i + 1}), (_results[${i}] = { error: ${err} }), _checkDone())) {\n`;
                        code += doneBreak(true);
                        code += "} else {\n";
                        code += done();
                        code += "}\n";
                        return code;
                    },
                    onResult: (i, result, done, doneBreak)=>{
                        var code = "";
                        code += `if(${i} < _results.length && (${result} !== undefined && (_results.length = ${i + 1}), (_results[${i}] = { result: ${result} }), _checkDone())) {\n`;
                        code += doneBreak(true);
                        code += "} else {\n";
                        code += done();
                        code += "}\n";
                        return code;
                    },
                    onTap: (i, run, done, _doneBreak)=>{
                        var code = "";
                        if (i > 0) {
                            code += `if(${i} >= _results.length) {\n`;
                            code += done();
                            code += "} else {\n";
                        }
                        code += run();
                        if (i > 0) code += "}\n";
                        return code;
                    },
                    onDone
                });
                return code;
            }
        }
    ]);
    return AsyncParallelBailHookCodeFactory;
}(HookCodeFactory);
var factory = new AsyncParallelBailHookCodeFactory();
function COMPILE(options) {
    factory.setup(this, options);
    return factory.create(options);
}
function AsyncParallelBailHook() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var hook = new Hook(args, name);
    hook.constructor = AsyncParallelBailHook;
    hook.compile = COMPILE;
    hook._call = undefined;
    hook.call = undefined;
    return hook;
}
AsyncParallelBailHook.prototype = null;
module.exports = AsyncParallelBailHook;
